import axios from 'axios';

const patch = !window?.location?.host?.includes('localhost') ? '/cview' : '';

export const client = axios.create({
  baseURL: `${window.location.protocol}//${window.location.host}${patch}/api`,
});
